import { defineStore } from "pinia";
import {
  collection,
  query,
  getFirestore,
  where,
  getDocs,
  limit,
  orderBy,
  getCountFromServer,
  deleteDoc
} from "firebase/firestore";
import { Ref, ref } from "vue";
import { userUserStore } from "../stores/user";

import { enviarMailInvitacion } from "./cloudFunctions/enviarMailInvitacion";
import {
  UsuarioSistemaInvitacion,
  usuarioSistemaInvitacionConverter
} from "@fixeduy/restaurantestypes";
export const useUsuariosInvitacionesStore = defineStore(
  "usuariosInvitaciones",
  () => {
    const db = getFirestore();
    const userStore = userUserStore();
    const documentos: Ref<UsuarioSistemaInvitacion[]> = ref([]);
    const mostrar = 10;
    const cargando = ref(false);
    const total = ref(0);
    const collectionRoute = `empresas/${
      userStore.empresa!.id
    }/usuarios-invitaciones/`;

    const firestoreQuery = () => {
      return query(
        collection(db, collectionRoute),
        orderBy("enviadaEl", "desc"),
        limit(mostrar)
      ).withConverter(usuarioSistemaInvitacionConverter);
    };

    const init = () => {
      total.value = 0;
      documentos.value = [];
      contar();
    };

    const contar = () => {
      getCountFromServer(query(collection(db, collectionRoute))).then(res => {
        total.value = res.data().count;
        get();
      });
    };

    const get = async () => {
      if (documentos.value.length >= total.value || cargando.value) return;

      cargando.value = true;
      getDocs(firestoreQuery()).then(querySnapshot => {
        querySnapshot.forEach(doc => {
          documentos.value.push(doc.data());
        });
        cargando.value = false;
      });
    };

    const enviarMail = async (usuario: UsuarioSistemaInvitacion) => {
      return enviarMailInvitacion({
        idInvitacion: usuario.id
      });
    };

    const cancelar = async (mail: string) => {
      const invitaciones = await getDocs(
        query(collection(db, collectionRoute), where("mail", "==", mail))
      );

      for (let i = 0; i < invitaciones.docs.length; i++) {
        await deleteDoc(invitaciones.docs[i].ref);
      }
      init();
    };

    const existeInvitacion = async (mail: string) => {
      const existe = await getDocs(
        query(collection(db, collectionRoute), where("mail", "==", mail))
      );

      return existe.docs.length > 0;
    };

    return {
      init,
      documentos,
      cargando,
      existeInvitacion,
      total,
      contar,
      cancelar,
      get,
      enviarMail
    };
  }
);
